
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("e9mOl", function(module, exports) {
$parcel$export(module.exports, "LayoutViewRenderer", () => (parcelRequire("25SZo")).default);

var $25SZo = parcelRequire("25SZo");

});
parcelRegister("25SZo", function(module, exports) {
$parcel$export(module.exports, "default", () => $575dd21e8efd25f8$export$2e2bcd8739ae039);
/* layout-view-renderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $iuRqK = parcelRequire("iuRqK");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hO5qW = parcelRequire("hO5qW");

var $jHj1h = parcelRequire("jHj1h");

var $a2qIF = parcelRequire("a2qIF");

var $fz2hV = parcelRequire("fz2hV");

var $dACnQ = parcelRequire("dACnQ");

var $6WltM = parcelRequire("6WltM");

var $hYh8H = parcelRequire("hYh8H");

var $haAAx = parcelRequire("haAAx");

var $51XYw = parcelRequire("51XYw");
parcelRequire("khEbD");
var $iZVVM = parcelRequire("iZVVM");

var $lnyeL = parcelRequire("lnyeL");
const $575dd21e8efd25f8$var$LayoutViewRenderer = (props)=>{
    var _data$sections, _data$sections2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { data: data, loadNext: loadNext, hasNext: hasNext, isLoadingNext: isLoadingNext } = (0, $a2qIF.usePaginationFragment)((0, $iuRqK.default), props.layout);
    const firstSectionRef = (_data$sections = data.sections) === null || _data$sections === void 0 || (_data$sections = _data$sections.edges) === null || _data$sections === void 0 || (_data$sections = _data$sections[0]) === null || _data$sections === void 0 ? void 0 : _data$sections.node;
    const sections = data === null || data === void 0 || (_data$sections2 = data.sections) === null || _data$sections2 === void 0 || (_data$sections2 = _data$sections2.edges) === null || _data$sections2 === void 0 ? void 0 : _data$sections2.map((edge)=>edge === null || edge === void 0 ? void 0 : edge.node);
    const { ref: ref, inView: inView } = (0, $jHj1h.useInView)({
        threshold: 0
    });
    (0, $bSJIT.useEffect)(()=>{
        if (hasNext && inView) loadNext((0, $lnyeL.LAYOUT_VIEW_RENDERER_PAGE_SIZE), {
            onComplete: (error)=>{
                if (error) {
                    if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                        action: 'pagination_failed',
                        actionSubject: 'homepageLayout',
                        analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                        error: error.message
                    }).fire();
                } else createAnalyticsEvent({
                    action: 'pagination_success',
                    actionSubject: 'homepageLayout',
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE)
                }).fire();
            }
        });
    }, [
        createAnalyticsEvent,
        hasNext,
        inView,
        loadNext
    ]);
    if (!sections) return null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), null, sections.map((section)=>{
        if (!section) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iZVVM.default), {
            section: section,
            key: section.__id
        });
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: "pagination-sentinel",
        style: {
            height: '20px'
        },
        ref: ref
    }), isLoadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hO5qW.default), {
        removeHeader: true,
        sectionCount: 2
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($575dd21e8efd25f8$var$LayoutViewRendererWrapper, {
        "data-testid": "layout-view-renderer"
    }, firstSectionRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dACnQ.LayoutHeader), {
        firstSectionFragment: firstSectionRef
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fz2hV.SkipToMainContent), null, content));
};
var $575dd21e8efd25f8$export$2e2bcd8739ae039 = $575dd21e8efd25f8$var$LayoutViewRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $575dd21e8efd25f8$var$LayoutViewRendererWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iuRqK", function(module, exports) {
$parcel$export(module.exports, "default", () => $59e1f2703123c29e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a1e3a57b8c7ac932bb43ea8e2ff25bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $fNlr4 = parcelRequire("fNlr4");
const $59e1f2703123c29e$var$node = function() {
    var v0 = [
        "sections"
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 10,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "kind": "RootArgument",
                "name": "helpCenterAri"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "count",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $fNlr4.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "layoutViewRendererFragment",
        "selections": [
            v1 /*: any*/ ,
            {
                "alias": "sections",
                "concreteType": "HelpLayoutSectionConnection",
                "kind": "LinkedField",
                "name": "__layoutRendererFragment_sections_connection",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "concreteType": "HelpLayoutSectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "HelpLayoutSection",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "sectionViewRendererFragment"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "layoutHeaderFragment"
                                    },
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__id"
                                            }
                                        ]
                                    },
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "HelpLayout"
    };
}();
$59e1f2703123c29e$var$node.hash = "f0e36a298e34cd645390386fd7cd202a";
var $59e1f2703123c29e$export$2e2bcd8739ae039 = $59e1f2703123c29e$var$node;

});
parcelRegister("fNlr4", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdf27eb3a7d1276e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7c28a5d9f15dddc3a15a22a8bf357833>>
 * @relayHash 0187c889600328eec9299ef7b4a638a8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a40c7cd4b2c60e6d23a2e31ed930334b7e6d3e71754052fdcbdb900e4dffca3c
const $cdf27eb3a7d1276e$var$node = function() {
    var v0 = [
        {
            "defaultValue": 10,
            "kind": "LocalArgument",
            "name": "count"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cursor"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v8 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v9 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v10 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "message"
    }, v12 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v15 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v16 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "layoutRendererRefetchQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "count",
                                    "variableName": "count"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "layoutViewRendererFragment"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "layoutRendererRefetchQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "HelpLayoutSectionConnection",
                                    "kind": "LinkedField",
                                    "name": "sections",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "HelpLayoutSectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSection",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSubsection",
                                                            "kind": "LinkedField",
                                                            "name": "subsections",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsectionConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "span"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "elements",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v2 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isHelpLayoutElement"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "adf"
                                                                                },
                                                                                {
                                                                                    "concreteType": "HelpLayoutAtomicElementType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "elementType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Variable",
                                                                                                    "name": "parentAri",
                                                                                                    "variableName": "helpCenterAri"
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "HelpLayoutMediaConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "mediaConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaCollectionName"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaToken"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaUrl"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "asapIssuer"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutEditorElement"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutPortalCard",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "portals",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "description"
                                                                                        },
                                                                                        v7 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isFeatured"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "expandButtonTextColor"
                                                                                },
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpLayoutPortalsListElement"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutRequestForm",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "suggestedRequestTypes",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "descriptionHtml"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "portalName"
                                                                                        },
                                                                                        v3 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "iconUrl"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "header"
                                                                                },
                                                                                v11 /*: any*/ ,
                                                                                v10 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpLayoutAnnouncementElement"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutTopic",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "topics",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "topicId"
                                                                                        },
                                                                                        v12 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopicItem",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v2 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "title"
                                                                                                },
                                                                                                v7 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "displayLink"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "entityKey"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "helpObjectType"
                                                                                                },
                                                                                                v13 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "topicName"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpLayoutTopicsListElement"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "useGlobalSettings"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "homePageTitle"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "userLanguageTag"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "showCSMAISearchTrigger"
                                                                                },
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "foregroundColor"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v15 /*: any*/ ,
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v10 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpLayoutHeroElement"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v10 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpLayoutNoContentElement"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "forgeElementType"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "forgeElementPage"
                                                                                },
                                                                                v10 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpLayoutForgeElement"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "connectElementPage"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "connectElementType"
                                                                                },
                                                                                v10 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpLayoutConnectElement"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "identifier"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "extensions",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v2 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "statusCode"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ],
                                                                            "type": "QueryError"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutBreadcrumb",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "items",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "relativeUrl"
                                                                                        },
                                                                                        v6 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v10 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpLayoutBreadcrumbElement"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v3 /*: any*/ 
                                                                            ],
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        v13 /*: any*/ 
                                                                    ]
                                                                },
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "visualConfig",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutAlignmentSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "alignment",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "horizontalAlignment"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "verticalAlignment"
                                                                                        },
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "HelpLayoutVisualEntity",
                                                                    "abstractKey": "__isHelpLayoutVisualEntity"
                                                                },
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "HelpLayoutVisualConfig",
                                                            "kind": "LinkedField",
                                                            "name": "visualConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v16 /*: any*/ ,
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        v3 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "layoutRendererFragment_sections",
                                    "kind": "LinkedHandle",
                                    "name": "sections"
                                }
                            ],
                            "type": "HelpLayout"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a40c7cd4b2c60e6d23a2e31ed930334b7e6d3e71754052fdcbdb900e4dffca3c",
            "metadata": {},
            "name": "layoutRendererRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cdf27eb3a7d1276e$var$node.hash = "f0e36a298e34cd645390386fd7cd202a";
var $cdf27eb3a7d1276e$export$2e2bcd8739ae039 = $cdf27eb3a7d1276e$var$node;

});


parcelRegister("khEbD", function(module, exports) {
$parcel$export(module.exports, "SectionViewRenderer", () => (parcelRequire("iZVVM")).default);

var $iZVVM = parcelRequire("iZVVM");

});
parcelRegister("iZVVM", function(module, exports) {
$parcel$export(module.exports, "default", () => $695e067f7ed70fd2$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $edKNU = parcelRequire("edKNU");

var $cQ9aQ = parcelRequire("cQ9aQ");
const $695e067f7ed70fd2$var$selector = (0, $BOq7h.createSelector)((0, $edKNU.getHelpCenterTopBarSplitFlag), (hasTopBarBeenSplit)=>({
        hasTopBarBeenSplit: hasTopBarBeenSplit
    }));
var $695e067f7ed70fd2$export$2e2bcd8739ae039 = (0, $egQxE.connect)($695e067f7ed70fd2$var$selector, {})((0, $cQ9aQ.default));

});
parcelRegister("cQ9aQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $487efad5e723e990$export$2e2bcd8739ae039);
/* section-view-renderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $6Oyv5 = parcelRequire("6Oyv5");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $lFpPv = parcelRequire("lFpPv");

var $a2qIF = parcelRequire("a2qIF");

var $bsfOD = parcelRequire("bsfOD");

var $gUpf2 = parcelRequire("gUpf2");
var $9BVpB = parcelRequire("9BVpB");

var $hbgJY = parcelRequire("hbgJY");

var $9QsVF = parcelRequire("9QsVF");

var $33Um8 = parcelRequire("33Um8");
parcelRequire("7W1vX");
var $k074W = parcelRequire("k074W");

var $9Cywr = parcelRequire("9Cywr");
const $487efad5e723e990$export$efc1dbea8bc84f74 = 'layout-section';
const $487efad5e723e990$var$SectionViewRenderer = ({ section: section, hasTopBarBeenSplit: hasTopBarBeenSplit })=>{
    var _sectionData$visualCo, _sectionData$visualCo2, _sectionData$subsecti, _sectionData$visualCo3;
    const sectionData = (0, $a2qIF.useFragment)((0, $6Oyv5.default), section);
    const sectionRef = (0, $bSJIT.useRef)(null);
    const subsections = sectionData === null || sectionData === void 0 ? void 0 : sectionData.subsections;
    let backgroundColor = sectionData === null || sectionData === void 0 || (_sectionData$visualCo = sectionData.visualConfig) === null || _sectionData$visualCo === void 0 ? void 0 : _sectionData$visualCo.backgroundColor;
    let backgroundImageUrl = sectionData === null || sectionData === void 0 || (_sectionData$visualCo2 = sectionData.visualConfig) === null || _sectionData$visualCo2 === void 0 || (_sectionData$visualCo2 = _sectionData$visualCo2.backgroundImage) === null || _sectionData$visualCo2 === void 0 ? void 0 : _sectionData$visualCo2.url;
    const isIncreasedFlexibilityEnabledWithTopBarSplit = (0, $lFpPv.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit;
    if (isIncreasedFlexibilityEnabledWithTopBarSplit) {
        const visualConfigStyle = (0, $hbgJY.backgroundStyleFromVisualConfig)(sectionData === null || sectionData === void 0 ? void 0 : sectionData.visualConfig);
        backgroundColor = visualConfigStyle.backgroundColor;
        backgroundImageUrl = visualConfigStyle.backgroundImage;
    }
    const { cachedBannerUrl: cachedBannerUrl } = (0, $33Um8.useCachedUrl)(backgroundImageUrl);
    const sectionId = sectionData.__id;
    const element = sectionData === null || sectionData === void 0 || (_sectionData$subsecti = sectionData.subsections) === null || _sectionData$subsecti === void 0 || (_sectionData$subsecti = _sectionData$subsecti[0]) === null || _sectionData$subsecti === void 0 || (_sectionData$subsecti = _sectionData$subsecti.elements) === null || _sectionData$subsecti === void 0 ? void 0 : _sectionData$subsecti[0];
    const canApplySectionBackground = (0, $9QsVF.useApplySectionBackground)({
        sectionTypename: (element === null || element === void 0 ? void 0 : element.__typename) || ''
    });
    (0, $9Cywr.useSectionAndElementId)((element === null || element === void 0 ? void 0 : element.__typename) || '', sectionId, (element === null || element === void 0 ? void 0 : element.__id) || '');
    const isSectionHidden = Boolean(sectionData === null || sectionData === void 0 || (_sectionData$visualCo3 = sectionData.visualConfig) === null || _sectionData$visualCo3 === void 0 ? void 0 : _sectionData$visualCo3.hidden);
    const sectionCustomProp = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        return {
            style: canApplySectionBackground ? {
                backgroundImage: cachedBannerUrl && !isSectionHidden ? `url(${cachedBannerUrl})` : 'inherit',
                backgroundColor: isIncreasedFlexibilityEnabledWithTopBarSplit && backgroundColor ? backgroundColor : 'initial'
            } : {}
        };
    }, [
        backgroundColor,
        cachedBannerUrl,
        canApplySectionBackground,
        isIncreasedFlexibilityEnabledWithTopBarSplit,
        isSectionHidden
    ]);
    if (!sectionData || !sectionId) return null;
    if (!subsections || isSectionHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($487efad5e723e990$var$BoxSectionWrapper, {
        backgroundColor: !isIncreasedFlexibilityEnabledWithTopBarSplit && canApplySectionBackground ? backgroundColor : undefined,
        isHidden: isSectionHidden,
        "data-testid": "layout-section-box-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        id: sectionId,
        ref: sectionRef,
        as: 'section',
        testId: $487efad5e723e990$export$efc1dbea8bc84f74,
        xcss: $487efad5e723e990$var$styledSection,
        ...sectionCustomProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bsfOD.Grid), {
        testId: "layout-section-grid",
        hasInlinePadding: !(0, $lFpPv.isIncreasedFlexibilityEnabled)()
    }, subsections.map((subsection)=>{
        if (!subsection) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k074W.default), {
            key: subsection.__id,
            subsection: subsection
        });
    }))));
};
var $487efad5e723e990$export$2e2bcd8739ae039 = $487efad5e723e990$var$SectionViewRenderer;
const $487efad5e723e990$var$styledSection = (0, $9BVpB.xcss)({
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $487efad5e723e990$var$BoxSectionWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_128mzge": (0, $3zY6O.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "",
            __cmplp.backgroundColor && !__cmplp.isHidden ? "_bfhkmpv7" : "_bfhkglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6Oyv5", function(module, exports) {
$parcel$export(module.exports, "default", () => $24d5c6e1db347691$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<efe7e256fea930eede45035e2718d14d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $24d5c6e1db347691$var$node = function() {
    var v0 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "sectionViewRendererFragment",
        "selections": [
            {
                "concreteType": "HelpLayoutSubsection",
                "kind": "LinkedField",
                "name": "subsections",
                "plural": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "subsectionViewRendererFragment"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "elements",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__typename"
                            },
                            v0 /*: any*/ 
                        ]
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "HelpLayoutVisualConfig",
                "kind": "LinkedField",
                "name": "visualConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "backgroundColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "backgroundType"
                    },
                    {
                        "concreteType": "HelpLayoutBackgroundImage",
                        "kind": "LinkedField",
                        "name": "backgroundImage",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hidden"
                    }
                ]
            },
            v0 /*: any*/ 
        ],
        "type": "HelpLayoutSection"
    };
}();
$24d5c6e1db347691$var$node.hash = "6bcf831b6636972d2d3b732d17d7324f";
var $24d5c6e1db347691$export$2e2bcd8739ae039 = $24d5c6e1db347691$var$node;

});

parcelRegister("7W1vX", function(module, exports) {
$parcel$export(module.exports, "SubsectionViewRenderer", () => (parcelRequire("k074W")).default);

var $k074W = parcelRequire("k074W");

});
parcelRegister("k074W", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf298ebf2ffc7003$export$2e2bcd8739ae039);
/* subsection-view-renderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $17D9U = parcelRequire("17D9U");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $jcRK7 = parcelRequire("jcRK7");

var $lFpPv = parcelRequire("lFpPv");

var $a2qIF = parcelRequire("a2qIF");

var $bxT0a = parcelRequire("bxT0a");

var $365Qe = parcelRequire("365Qe");

var $BkxYp = parcelRequire("BkxYp");

var $c3QJe = parcelRequire("c3QJe");

var $hzaNv = parcelRequire("hzaNv");
const $bf298ebf2ffc7003$var$SubsectionViewRenderer = ({ subsection: subsection })=>{
    var _subsectionData$confi, _subsectionData$confi2;
    const [ElementRenderer] = (0, $c3QJe.useElementRenderer)();
    const subsectionData = (0, $a2qIF.useFragment)((0, $17D9U.default), subsection);
    const subsectionId = subsectionData.__id;
    const alignmentSettings = (0, $bxT0a.useAlignmentSettings)(subsectionData.visualConfig ?? null);
    const elements = (0, $bSJIT.useMemo)(()=>subsectionData.elements || [], [
        subsectionData.elements
    ]);
    const isValidSpanOption = (n)=>{
        return typeof n === 'number' && n > 0 && n < 13 || n === 'none';
    };
    let span = 12;
    if ((_subsectionData$confi = subsectionData.config) !== null && _subsectionData$confi !== void 0 && _subsectionData$confi.span && isValidSpanOption((_subsectionData$confi2 = subsectionData.config) === null || _subsectionData$confi2 === void 0 ? void 0 : _subsectionData$confi2.span)) {
        var _subsectionData$confi3;
        span = (_subsectionData$confi3 = subsectionData.config) === null || _subsectionData$confi3 === void 0 ? void 0 : _subsectionData$confi3.span;
    }
    const horizontalAlignment = alignmentSettings.horizontalAlignment;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $365Qe.GridItem), {
        span: {
            sm: span
        },
        "data-testid": "layout-subsection"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bf298ebf2ffc7003$var$SubsectionChildWrapper, {
        id: subsectionData.__id
    }, elements && elements.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($bf298ebf2ffc7003$var$CoveredStack, {
        horizontalAlignment: horizontalAlignment
    }, elements.map((element)=>element && ((0, $lFpPv.isElementRendererSplitEnabled)() && ElementRenderer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzaNv.ElementErrorBoundary), {
            screenName: (0, $jcRK7.ScreenName).VIEW_HOMEPAGE,
            helpLayoutElement: element,
            key: element.__id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ElementRenderer, {
            key: element.__id,
            element: element,
            parentSubsectionId: subsectionId
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzaNv.ElementErrorBoundary), {
            screenName: (0, $jcRK7.ScreenName).VIEW_HOMEPAGE,
            key: element.__id,
            helpLayoutElement: element
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $BkxYp.HomePageElementViewRenderer), {
            key: element.__id,
            element: element,
            parentSubsectionId: subsectionId
        })))))));
};
var $bf298ebf2ffc7003$export$2e2bcd8739ae039 = $bf298ebf2ffc7003$var$SubsectionViewRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bf298ebf2ffc7003$var$SubsectionChildWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_4t3i1osq _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $bf298ebf2ffc7003$var$CoveredStack = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { horizontalAlignment: horizontalAlignment, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ajlr49": (0, $3zY6O.default)((__cmplp.horizontalAlignment ?? 'left').toLowerCase())
        },
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_zulpu2gc _4t3i1osq _1e0c1txw _vchhusvi _2lx21bp4 _y3gn1ckq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("17D9U", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc63d6223c4c924c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d8337433f71716dd4ed9d650ad42aa97>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc63d6223c4c924c$var$node = function() {
    var v0 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "subsectionViewRendererFragment",
        "selections": [
            {
                "concreteType": "HelpLayoutSubsectionConfig",
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "span"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "elements",
                "plural": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "homePageElementViewRendererFragment"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "customPageElementViewRendererFragment"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "elementErrorBoundaryFragment"
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "HelpLayoutVisualConfig",
                        "kind": "LinkedField",
                        "name": "visualConfig",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "alignmentSettingsContextFragment"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "alignmentSettingsContextHookFragment"
                            }
                        ]
                    }
                ],
                "type": "HelpLayoutVisualEntity",
                "abstractKey": "__isHelpLayoutVisualEntity"
            },
            v0 /*: any*/ 
        ],
        "type": "HelpLayoutSubsection"
    };
}();
$fc63d6223c4c924c$var$node.hash = "92b814fe8e4ce783d39301c2a771dfb8";
var $fc63d6223c4c924c$export$2e2bcd8739ae039 = $fc63d6223c4c924c$var$node;

});

parcelRegister("BkxYp", function(module, exports) {
$parcel$export(module.exports, "HomePageElementViewRenderer", () => $f06b993ae7cef562$export$641266abe3ba99ed);
$parcel$export(module.exports, "default", () => $f06b993ae7cef562$export$2e2bcd8739ae039);

var $1RsPR = parcelRequire("1RsPR");

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");


var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $hzaNv = parcelRequire("hzaNv");
parcelRequire("6u8nu");

var $4u8Jv = parcelRequire("4u8Jv");

var $51XYw = parcelRequire("51XYw");

var $3e2Io = parcelRequire("3e2Io");

var $lBa45 = parcelRequire("lBa45");

var $kTPsj = parcelRequire("kTPsj");

var $1uKeu = parcelRequire("1uKeu");

var $daK6i = parcelRequire("daK6i");

var $fIqDf = parcelRequire("fIqDf");

var $3AFAl = parcelRequire("3AFAl");

var $aIkvq = parcelRequire("aIkvq");
const $f06b993ae7cef562$export$641266abe3ba99ed = ({ element: elementKey })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const elementData = (0, $a2qIF.useFragment)((0, $1RsPR.default), elementKey);
    switch(elementData.__typename){
        case 'HelpLayoutEditorElement':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3e2Io.default), {
                editorElement: elementData
            });
        case 'HelpLayoutHeroElement':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lBa45.HeroElement), {
                heroElement: elementData
            });
        case 'HelpLayoutAnnouncementElement':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4u8Jv.HelpCenterAnnouncement), {
                announcementElement: elementData
            });
        case 'HelpLayoutTopicsListElement':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fIqDf.ListOfTopics), {
                topicsElement: elementData
            });
        case 'HelpLayoutPortalsListElement':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $daK6i.ListOfPortals), {
                listOfHelpCenters: elementData
            });
        case 'HelpLayoutSuggestedRequestFormsListElement':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aIkvq.SuggestedRequestForms), {
                forms: elementData
            });
        case 'HelpLayoutForgeElement':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1uKeu.ForgeElement), {
                forgeElementRef: elementData
            });
        case 'HelpLayoutConnectElement':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kTPsj.ConnectElement), {
                connectElementRef: elementData
            });
        case 'HelpLayoutNoContentElement':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3AFAl.NoContent), null);
        case 'QueryError':
            {
                const elementIdentifier = elementData.identifier || 'UNKNOWN';
                let statusCode = (0, $jcRK7.HTTP).SERVER;
                if (elementData.extensions && Array.isArray(elementData.extensions) && elementData.extensions.length > 0) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                statusCode = elementData.extensions[0].statusCode;
                throw new (0, $51XYw.FetchError)(`${elementIdentifier} content failed to load`, statusCode, true);
            }
        default:
            return null;
    }
};
// TODO: Break this into separate files and add VR tests
const $f06b993ae7cef562$var$HomePageElementViewRendererWithErrorBoundary = (props)=>{
    return(/**
     * ErrorBoundary returns null unless renderError prop is passed,
     * if we want custom error message per element, individual elements can be wrapped with this error boundary
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzaNv.ElementErrorBoundary), {
        screenName: (0, $jcRK7.ScreenName).VIEW_HOMEPAGE,
        helpLayoutElement: props.element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($f06b993ae7cef562$export$641266abe3ba99ed, props)));
};
var $f06b993ae7cef562$export$2e2bcd8739ae039 = $f06b993ae7cef562$var$HomePageElementViewRendererWithErrorBoundary;

});
parcelRegister("1RsPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2201c405311240b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dff1b28b757dafcb4872a137b43c1cdb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2201c405311240b4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "homePageElementViewRendererFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "editorViewRendererFragment"
                }
            ],
            "type": "HelpLayoutEditorElement"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement"
                }
            ],
            "type": "HelpLayoutPortalsListElement"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement"
                }
            ],
            "type": "HelpLayoutSuggestedRequestFormsListElement"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "helpCenterAnnouncementFragment"
                }
            ],
            "type": "HelpLayoutAnnouncementElement"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "listOfTopicsElementFragment"
                }
            ],
            "type": "HelpLayoutTopicsListElement"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "heroElementFragment"
                }
            ],
            "type": "HelpLayoutHeroElement"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "forgeElementFragment"
                }
            ],
            "type": "HelpLayoutForgeElement"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "connectElementFragment"
                }
            ],
            "type": "HelpLayoutConnectElement"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "identifier"
                },
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                }
            ],
            "type": "QueryError"
        }
    ],
    "type": "HelpLayoutElement",
    "abstractKey": "__isHelpLayoutElement"
};
$2201c405311240b4$var$node.hash = "0f4762a0acd0066592f62e418094e1d8";
var $2201c405311240b4$export$2e2bcd8739ae039 = $2201c405311240b4$var$node;

});







parcelRegister("lnyeL", function(module, exports) {
$parcel$export(module.exports, "LAYOUT_VIEW_RENDERER_PAGE_SIZE", () => $b6355a5c93363ed7$export$b82572916eb0ffd3);
const $b6355a5c93363ed7$export$b82572916eb0ffd3 = 10;

});




//# sourceMappingURL=shared.881b482f.js.map
